import { type State } from "./activeCourse.state";

export enum ActionTypes {
  SET_ACTIVE_COURSE = "SET_ACTIVE_COURSE",
}

export const setActiveCourse = (courseId: State) => ({
  type: ActionTypes.SET_ACTIVE_COURSE as const,
  payload: {
    courseId,
  },
});

const Actions = {
  setActiveCourse,
};

export type GenericAction = {
  type: string;
  payload?: {
    courseId?: State;
    location?: Location;
  };
};

export type Actions = typeof Actions;
export type ActionKeys = keyof Actions;
export type Action = Actions[ActionKeys];
export type ActionReturns = ReturnType<Action> | GenericAction;
